import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError, buildQuery } from '@/views/skud/shared/modules/skud-http'

export class SkudGuestEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // body: {request_id, place_id, channel, visitor_name?, purpose?, host_subject_ref?, valid_from, valid_to, points?}
  // -> {ok: true, data} | {ok: false, error}
  async createGuest (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/guest/create', body)
    const data = unwrapEnvelope(res)
    return data ? { ok: true, data } : { ok: false, error: envelopeError(res) }
  }

  // body: {public_id, reason?}
  // -> {ok: true, data} | {ok: false, error}
  async revokeGuest (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/guest/revoke', body)
    const data = unwrapEnvelope(res)
    return data ? { ok: true, data } : { ok: false, error: envelopeError(res) }
  }

  // params: {from?, to?, state?} — лимит 500 зашит на сервере, пагинации нет.
  // placeId не задан -> client-scope GET /guest/list. -> {items} или null.
  async getGuests (placeId, params) {
    const seg = placeId ? 'places/' + placeId + '/' : ''
    const res = await this.webApi.get(this.url + seg + 'guest/list?' + buildQuery(params || {}))
    return unwrapEnvelope(res)
  }

  // -> объект гостевого пропуска или null.
  async getGuest (placeId, publicId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/guest/' + publicId)
    return unwrapEnvelope(res)
  }
}
